<template>
  <nav
    class="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row"
  >
    <div
      class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
    >
      <a class="navbar-brand brand-logo">
        <img
          src="../../../assets/images/maxcess-logo.png"
          style="height: 100% !important"
          alt="logo"
      /></a>
      <a class="navbar-brand brand-logo-mini"
        ><img
          src="../../../assets/images/maxcess-logo.png"
          alt="logo"
          style="width: 100%; margin-left: 10px; height: 100%"
      /></a>
    </div>
    <div class="navbar-menu-wrapper d-flex align-items-stretch">
      <button
        class="navbar-toggler navbar-toggler align-self-center"
        type="button"
        data-toggle="minimize"
        @click="toggelMenu()"
      >
        <span class="mdi mdi-menu"></span>
      </button>

      <ul class="navbar-nav navbar-nav-right">
        <li class="nav-item nav-profile dropdown">
          <a
            class="nav-link dropdown-toggle"
            id="profileDropdown"
            href="#"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <div class="nav-profile-img">
              <img src="../../../assets/images/user-icon.png" alt="image" />
              <span class="availability-status online"></span>
            </div>
            <div class="nav-profile-text" v-if="user">
              <!-- <p class="mb-1 text-black">user name</p> -->
              <p class="mb-1 text-black">{{ user.usr_user_name }}</p>
            </div>
          </a>
          <div
            class="dropdown-menu navbar-dropdown"
            aria-labelledby="profileDropdown"
            v-if="user"
          >
            <a class="dropdown-item">
              <i class="mdi mdi-account me-2 text-success"></i
              >{{ user.usr_user_name }} ({{ user.usr_role.url_role_desc }})
            </a>
            <p class="p-2">{{ user.usr_email }}</p>

            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="auth_store.logout">
              <i class="mdi mdi-logout me-2 text-primary"></i> Signout
            </a>
          </div>
        </li>
        <li class="nav-item d-none d-lg-block full-screen-link">
          <a class="nav-link">
            <i class="mdi mdi-fullscreen" id="fullscreen-button"></i>
          </a>
        </li>
      </ul>
      <button
        class="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
        type="button"
        data-toggle="offcanvas"
        @click="toggelMenu()"
      >
        <span class="mdi mdi-menu"></span>
      </button>
    </div>
  </nav>
</template>

<script setup>
import { useAuthStore } from "@/store/auth_store";
import { ref, onMounted } from "vue";
const auth_store = useAuthStore();
const user = ref(null);

onMounted(() => {
  user.value = auth_store.logged_in_user.user;
});

const toggelMenu = () => {
  auth_store.toggleMenuBar();
};
</script>
